import { SCREEN_SIZES } from 'modules/utils/screenSizes';
import { useMediaQuery } from 'react-responsive';
import { DesktopDataAndAnalytics } from './Data&Analytics.desktop';
import { MobileDataAndAnalytics } from './Data&Analytics.mobile';

export const DataAndAnalytics = () => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${SCREEN_SIZES.mobile})`,
  });

  if (isMobile) return <MobileDataAndAnalytics />;

  return <DesktopDataAndAnalytics />;
};
